import { AutoComplete, Typography } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/ds-react-utils";
import styled from "@emotion/styled";
import { Controller, useFormContext } from "react-hook-form";
import { FieldTypeOption } from "@kaltura/mediaspace-shared-types";

export interface TimezonesProps {
    timezones: FieldTypeOption[];
}

export const StyledAutoComplete = styled(AutoComplete)(({ theme }) => ({
    padding: 0,
    marginTop: theme.spacing(1),
}));

const getOptionLabel = (option: FieldTypeOption) => option.label;

const Timezones = ({ timezones }: TimezonesProps) => {
    const { control } = useFormContext();
    const timezoneInputId = "timezone-input";
    const timezoneLabelId = "timezone-label";

    return (
        <div role="group">
            <Typography id={timezoneLabelId} variant={"formLabel"} component="label" htmlFor={timezoneInputId}>
                {translate("Time zone")}
            </Typography>{" "}
            <Controller
                name="tz"
                control={control}
                render={({ field }) => (
                    <StyledAutoComplete
                        options={timezones}
                        getOptionLabel={getOptionLabel}
                        onChange={(_event, newValue) => {
                            field.onChange(newValue?.value || "");
                        }}
                        value={timezones.find((timezone) => timezone.value === field.value) || null}
                        multiple={false}
                        fullWidth={true}
                        id={timezoneInputId}
                        role="combobox"
                        aria-expanded="false"
                        aria-haspopup="listbox"
                        aria-labelledby={timezoneLabelId}
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                    />
                )}
            />
        </div>
    );
};

export default Timezones;
